import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { api } from "../../../services/api/axios";


// fetch deposit
const fetchDeposit = async ({ page, limit, search }) => {
  const response = await api.get("/v1/admin/personal/manual-review-deposits", {
    params: { page, limit, ...(search && { search }) },
  });
  return response.data;
};

export const useDeposit = (page = 1, limit = 10, search = "") => {
  return useQuery({
    queryKey: ["deposit", page, limit, search],
    queryFn: () => fetchDeposit({ page, limit, search }),
    // Keep the previous page on screen while the next one loads.
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });
};

// approve deposit
const approveDeposit = async ({ uuid, ...payload }) => {
  const { data } = await api.post(
    `/v1/admin/personal/approve-deposit/${uuid}`,
    payload
  );
  return data;
};

export const useApproveDeposit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: approveDeposit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["deposit"] });
    },
  });
};

// decline deposit
const declineDeposit = async (payload) => {
  const { data } = await api.post(
    "/v1/admin/personal/decline-deposit",
    payload
  );
  return data;
};

export const useDeclineDeposit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: declineDeposit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["deposit"] });
    },
  });
};

// send manual review email
const sendManualReviewEmail = async (uuid) => {
  const { data } = await api.post(
    `/v1/admin/personal/send-manual-review-email/${uuid}`
  );
  return data;
};

export const useSendManualReviewEmail = () => {
  return useMutation({
    mutationFn: sendManualReviewEmail,
  });
};